export { BasicsPage as default } from '@/components/enpages/Ir/Governance/Basics'
